import Head from 'next/head';
import Terms from '../components/Terms-of-use/[slug].js';

export default function terms() {
    return (
        <>
            <Head>
                <title>Terms of Use – NEET Support</title>
                <meta
                    name="description"
                    content="Read NEET Support's Terms of Use to understand the rules and guidelines for accessing and using our NEET counseling platform."
                />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://neetsupport.com/terms" />
            </Head>
            <Terms />
        </>
    );
}
